import { TOrder } from '@/types/orders';
import { TQuestionnaireDocuments } from '@/types/questionnaires';

export const getDocument = (order: TOrder): TQuestionnaireDocuments | undefined => {
    const lastStatus = (() => {
        switch (order.status.type[order.status.type.length - 1]) {
            case 'sent_to_court':
            case 'issued':
            case 'delayed':
                return 'issued';

            default:
                return order.status.type[order.status.type.length - 1];
        }
    })();

    let document: { id?: number; state?: string } = {};

    order.documents.forEach((doc) => {
        if (lastStatus === doc.state) {
            if (!document?.id || doc.id > document.id) {
                document = doc;
            }
        }
    });

    if (document.state === lastStatus) {
        return document as TQuestionnaireDocuments;
    }
};
